import axiosInstance from "@/lib/axios";

export const advertisementService = {
  // Récupérer la liste paginée des publicités
  getAdvertisements: async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/admin/advertisements', { params });
    return response.data;
  },

  // Récupérer les détails d'une publicité
  getAdvertisementDetails: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/advertisements/${id}`);
    return response.data;
  },

  // Créer une nouvelle publicité (avec gestion des fichiers)
  createAdvertisement: async (data) => {
    const formData = new FormData();
    
    // Ajouter tous les champs au FormData
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });

    const response = await axiosInstance.post('/api/v1/admin/advertisements', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Mettre à jour une publicité existante
  updateAdvertisement: async (id, data) => {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        formData.append(key, data[key]);
      }
    });

    // Utilisation de POST avec _method=PUT pour une meilleure compatibilité avec les fichiers
    formData.append('_method', 'PUT');

    const response = await axiosInstance.post(`/api/v1/admin/advertisements/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Supprimer une publicité
  deleteAdvertisement: async (id) => {
    const response = await axiosInstance.delete(`/api/v1/admin/advertisements/${id}`);
    return response.data;
  },

  // Activer/Désactiver une publicité
  toggleAdvertisementStatus: async (id) => {
    const response = await axiosInstance.patch(`/api/v1/admin/advertisements/${id}/toggle-status`);
    return response.data;
  },

  // Méthode optionnelle pour récupérer les publicités actives (frontend)
  getActiveAdvertisements: async () => {
    const response = await axiosInstance.get('/api/v1/advertisements/active');
    return response.data;
  }
};